// extracted by mini-css-extract-plugin
export var header = "_um-1";
export var maskBottom = "_um-6";
export var maskMiddle = "_um-7";
export var maskTop = "_um-5";
export var root = "_um-0";
export var scrollDownButton = "_um-3";
export var scrollDownButtonHidden = "_um-4";
export var viewport = "_um-2";